import React from 'react';
import cx from 'classnames';

import { THEME } from '../../../config/commons';

import styles from './DotSpinner.module.scss';
import { getCurrentTheme } from '../../../utils/theme';


interface Props {
  theme?: 'dark' | 'light';
}

export default function DotSpinner ({ theme = getCurrentTheme() }: Props) {
  const isLightTheme = theme === THEME.LIGHT;

  return <div className={cx(styles.spinner, isLightTheme ? styles.spinnerLight : styles.spinnerDark)}>
    <div className={styles.dot1} />
    <div className={styles.dot2} />
    <div className={styles.dot3} />
  </div>;
}
